import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for balance history.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old balance gaps with specific background colors.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the cell.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for specific range
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight changed items
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'Partner', // Column for Partner
                                    header: _('Partner'), // Localized header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Template for rendering
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) +
                                                "<span class='partner " +
                                                obj.Partner +
                                                "'></span>"
                                            );
                                        return "<span class='partner " + obj.Partner + "'></span>";
                                    },
                                },
                                {
                                    id: 'CreatedLocalDate', // Column for creation date
                                    header: _('Fecha de creación'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 120,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Country', // Column for country
                                    header: _('País'), // Localized header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template for rendering
                                        return "<i class='flags " + obj.Country + "'></i>";
                                    },
                                },
                                {
                                    id: 'UserId', // Column for User ID
                                    header: _('ID Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column for User Name
                                    header: _('Nombre Usuario'), // Localized header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BalanceInitial', // Column for Initial Balance
                                    header: _('Saldo Inicial'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'AmountDeposits', // Column for Deposit Amount
                                    header: _('Depósitos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBets', // Column for Bets Amount
                                    header: _('Ap. Deportivas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWin', // Column for Win Amount
                                    header: _('Pr. Deportivas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'GgrAmountWin', // Column for GGR Win Amount
                                    header: _('GGR. Deportivas'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino', // Column for Casino Bets Amount
                                    header: _('Ap. Casino'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino', // Column for Casino Win Amount
                                    header: _('Pr. Casino'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'GgrAmountWinCasino', // Column for Casino GGR Win Amount
                                    header: _('GGR. Casino'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawCreates', // Column for Created Withdrawals
                                    header: _('Retiros Creados'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawDeletes', // Column for Deleted Withdrawals
                                    header: _('Retiros Eliminados'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE', // Column for Adjustment E
                                    header: _('Ajustes E'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentS', // Column for Adjustment S
                                    header: _('Ajustes S'), // Localized header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'Bonus', // Column for Bonuses
                                    header: _('Bonos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusCasino', // Column for Casino Bonuses
                                    header: _('Bonos casino'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusVirtual', // Column for Virtual Bonuses
                                    header: _('Bonos Virtuales'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusCasinoLive', // Column for Live Casino Bonuses
                                    header: _('Bonos Casino en vivo'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEnd', // Column for Final Balance
                                    header: _('Saldo Final'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEndCalc', // Column for Calculated Final Balance
                                    header: _('Saldo Final Calc.'), // Localized header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceGap', // Column for Balance Gap
                                    header: _('Calc. Desfase'), // Localized header
                                    width: 110,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    cssFormat: mark_old, // Custom CSS formatting function
                                },
                                {
                                    id: 'WithdrawPaid', // Column for Paid Withdrawals
                                    header: _('Retiros Pagados'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawPend', // Column for Pending Withdrawals
                                    header: _('Retiros Pendientes'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusFreeWin', // Column for Free Win Bonuses
                                    header: _('Bonos Free Ganados'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositsUsersCount', // Column for Depositing Users Count
                                    header: _('Usuarios Depositantes'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositsCount', // Column for Deposit Count
                                    header: _('Cantidad Depositos'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the component is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistory2'; // API URL
        var filter = ''; // Filter string

        // Event handler for after loading data
        grid.attachEvent('onAfterLoad', function () {
            $$('datatable').data.group({
                by: 'Partner', // Group by Partner
                map: {
                    Partner: ['Partner'], // Mapping for grouping
                },
            });
        });

        // Event handler for filtering balance history
        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                        if (object[i][0] === 'Date') {
                            // Handle date filter
                            var d = new Date(object[i][1]);
                            var dateFrom =
                                'dateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + d.getDate()).slice(-2);
                            string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                            var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0);
                            var dateTo =
                                'dateTo=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + ud.getDate()).slice(-2);
                            string1 = string1 + '&' + dateTo; // Add dateTo to query
                        }
                    }
                }
            }
            console.log(grid); // Log the grid for debugging
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });

        // Event handler for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
